import btnAuthority from '@/modules/mdm/btnAuthority.js';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';

export const tableConfig = {
    name: 'contractRegistration',
    selection: false,
    index: false,
    height: '375px',
    searchFields: [
        {
            name: '单据编号',
            value: 'contractCode',
            isFixed: true,
            type: 'input',
            span: 3
        },
        {
            name: '分公司',
            value: 'companyName',
            type: 'advance',
            // type: 'advanceMulti',
            isFixed: true,
            span: 3,
            advanceConfig: [
                { 'prop': 'companyName', 'value': '分公司名称' },
                { 'prop': 'companyCode', 'value': '分公司编码' },
                { 'prop': 'region', 'value': '片区' }
            ],
            tableConfig: [
                { 'prop': 'companyCode', 'value': '分公司编码' },
                { 'prop': 'companyName', 'value': '分公司名称', 'displayName': 'companyName' },
                { 'prop': 'region', 'value': '片区' }
            ],
            prefix: '/api-lcrm',
            advanceUrl: `/company/manager/archive/page`,
            method: 'post',
            cbParams: ['companyName', 'companyCode']
        }
        // {
        //     name: '待办跟进人',
        //     value: 'renewalContractors',
        //     type: 'advanceMulti',
        //     isFixed: true,
        //     span: 3,
        //     advanceConfig: [
        //         { 'prop': 'esusUserNameCn', 'value': '姓名' },
        //         { 'prop': 'esusLoginName', 'value': '美信号' },
        //         { 'prop': 'esusId', 'value': 'ID' }
        //     ],
        //     tableConfig: [
        //         { 'prop': 'esusId', 'value': 'ID' },
        //         { 'prop': 'esusLoginName', 'value': '美信号' },
        //         { 'prop': 'esusUserNameCn', 'value': '姓名', 'displayName': 'esusUserNameCn' },
        //         { 'prop': 'esusPositionName', 'value': '职位' },
        //         { 'prop': 'escoCompanyNameCn', 'value': '部门' }
        //     ],
        //     prefix: '/api-mdm',
        //     advanceUrl: `/selectUserCompany`,
        //     cbParams: ['esusUserNameCn#renewalContractor', 'esusLoginName#renewalContractorMip'],
        //     beforeRequest: (params) => {
        //         const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
        //         const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
        //         if (reg.test(inputKey)) {
        //             params.esusUserNameCn = inputKey;
        //             params.esusLoginName = null;
        //         } else {
        //             params.esusLoginName = inputKey;
        //             params.esusUserNameCn = null;
        //         }
        //         return params;
        //     }
        // }
    ],
    columns: [
        {
            label: '单据编号',
            prop: 'contractCode'
        },
        // {
        //     label: '待办内容',
        //     prop: 'content',
        //     width: 200
        // },
        {
            label: '分公司',
            prop: 'companyName'
        },
        {
            label: '待办跟进人姓名',
            prop: 'handlerName',
            value: 'handlerName',
            name: '修改待办跟进人',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' }
            ],
            tableConfig: [
                { 'prop': 'esusId', 'value': 'ID' },
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusPositionName', 'value': '职位' },
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/selectUserCompany`,
            cbParams: ['esusUserNameCn#handlerName', 'esusLoginName#handlerCode'],
            beforeRequest: (params) => {
                const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                if (reg.test(inputKey)) {
                    params.esusUserNameCn = inputKey;
                    params.esusLoginName = null;
                } else {
                    params.esusLoginName = inputKey;
                    params.esusUserNameCn = null;
                }
                return params;
            }
        },
        {
            label: '待办跟进人MIP',
            prop: 'handlerCode'
        }
    ],
    actions: { // 表格操作列的配置
        fixedWidth: 120, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
        list: []
    },
    rowEdit: otherUtils.getHasAuth(btnAuthority.renewalEdit.edit),
    getAuthRole: () => otherUtils.getHasAuth(btnAuthority.renewalEdit.edit),
    rowEnableEditFun: (row) => { // 是否可编辑（编辑按钮和双击编辑）
        const isAuth = otherUtils.getHasAuth(btnAuthority.renewalEdit.edit);
        return isAuth;
    }
};
